// extracted by mini-css-extract-plugin
module.exports = {"break":"MessageContent_break__IuTp0"};